<template>
  <div class="work-item-order">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>作業項目</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="sub-title">作業項目</div>
        <div style="margin: 10px 0">
          <select v-model="selectedSeasonId">
            <option
              v-for="item in seasons"
              :key="item.season_id"
              :value="item.season_id"
            >
              {{ item.season_name }}
            </option>
          </select>
        </div>
        <table class="stripe">
          <tr>
            <th class="no" align="center">#</th>
            <th class="season" >作業分類</th>
            <th class="item" >作業項目</th>
            <th class="sort" align="center" colspan="2">並び替え</th>
          </tr>
          <tr
            v-for="(row, index) in seasonItems[selectedSeasonId]"
            :key="row.item_id"
          >
            <td align="center">{{ index + 1 }}</td>
            <td>{{ row.season.season_name }}</td>
            <td>{{ row.item_name }}</td>
            <td align="center">
              <span
                class="btn-sort-up"
                :class="{
                  disable: index === 0,
                }"
                @click="onSortUp(index)"
              ></span>
            </td>
            <td align="center">
              <span
                class="btn-sort-down"
                :class="{
                  disable: index === seasonItems[selectedSeasonId].length - 1,
                }"
                @click="onSortDown(index)"
              ></span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div id="button-area">
      <div class="left-box" />
      <div class="center-box">
        <span class="btn btn-submit active" @click="onSubmitUpdateOrder"
          >保存</span
        >
        <span class="btn btn-cancel" @click="onCancel">キャンセル</span>
      </div>
      <div class="right-box"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/mixins/loader";

export default {
  components: {},

  mixins: [Loader],

  props: {},

  data() {
    return {
      seasons: [],
      seasonItems: {},
      selectedSeasonId: null,
    };
  },

  async mounted() {
    this.loading(async () => {
      try {
        this.seasons = await this.retrieveSeasons();
        this.seasonItems = [];
        // itemとseasonを合体
        this.seasons.forEach((season) => {
          this.seasonItems[season.season_id] = [];
          season.items.forEach((item) => {
            let wkItem = item;
            wkItem.season = season;
            // 並び替え用ソートキー設定
            wkItem.new_sort_key = wkItem.sort_key;
            this.seasonItems[season.season_id].push(wkItem);
          });
        });
        this.selectedSeasonId = this.seasons[0].season_id;
      } catch (error) {
        console.log(error);
        alert(error);
      }
    });
  },

  methods: {
    ...mapActions(["retrieveSeasons", "updateOrderItems"]),

    onCancel: function () {
      this.$router.push({ name: "works" });
    },
    async onSubmitUpdateOrder() {
      this.loading(async () => {
        const updateList = [];
        this.seasons.forEach((season) => {
          this.seasonItems[season.season_id].forEach((item) => {
            if (item.new_sort_key) {
              if (item.new_sort_key != item.sort_key) {
                // キーだけ設定する
                updateList.push({
                  account_id: item.account_id,
                  season_id: item.season_id,
                  item_id: item.item_id,
                  sort_key: item.sort_key,
                  new_sort_key: item.new_sort_key,
                });
              }
            }
          });
        });
        if (updateList.length > 0) {
          await this.updateOrderItems(updateList);
        }
        this.$router.push({ name: "works" });
      });
    },

    onSortUp(index) {
      if (index === 0) {
        return;
      }
      const _wkItems = this.seasonItems[this.selectedSeasonId];
      const tmp1 = _wkItems[index];
      const tmp2 = _wkItems[index - 1];
      // sortキーを入れ替える
      const tmp1Sort = tmp1.new_sort_key;
      const tmp2Sort = tmp2.new_sort_key;
      tmp1.new_sort_key = tmp2Sort;
      tmp2.new_sort_key = tmp1Sort;

      _wkItems[index] = tmp2;
      _wkItems[index - 1] = tmp1;
      this.$set(this.seasonItems, this.selectedSeasonId, _wkItems);
    },
    onSortDown(index) {
      if (index === this.seasonItems[this.selectedSeasonId].length - 1) {
        return;
      }
      const _wkItems = this.seasonItems[this.selectedSeasonId];
      const tmp1 = _wkItems[index];
      const tmp2 = _wkItems[index + 1];
      // sortキーを入れ替える
      const tmp1Sort = tmp1.new_sort_key;
      const tmp2Sort = tmp2.new_sort_key;
      tmp1.new_sort_key = tmp2Sort;
      tmp2.new_sort_key = tmp1Sort;

      _wkItems[index] = tmp2;
      _wkItems[index + 1] = tmp1;
      this.$set(this.seasonItems, this.selectedSeasonId, _wkItems);
    },
  },
};
</script>

<style lang="scss">
.work-item-order {
  .section {
    overflow: auto;
    width: 80%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 1rem;
      margin-left: auto;
      margin-right: auto;

      .sub-title {
        font-size: 18px;
        margin: 10px 0;
      }

      select {
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 38px 0 16px;
        font-size: 16px;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center;
        background-size: 25px 25px;
        white-space:nowrap;
        width:100%;
        overflow:hidden;
        text-overflow:ellipsis;
      }

      select:focus {
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center var(--purple-tertiary);
        background-size: 25px 25px;
      }
    }
  }
  table {
    width: 100%;
    border: solid 1px #ddd;
    font-size: 0.9rem;
    background: #fff;
  }
  th {
    padding: 8px;
    border-bottom: solid 1px #bbb;
    border-right: solid 1px #bbb;
    background: #ccc;
    font-weight: normal;

    &.no {
      width: 10%;
    }

    &.season {
      width: 40%;
    }

    &.item {
      width: 40%;
    }

    &.sort {
      width: 10%;
    }
  }

  th:nth-child(0) {
    border-right: none;
  }

  td {
    padding: 8px;
    border-bottom: solid 1px #ddd;
    border-right: solid 1px #ddd;
  }

  td:nth-child(0) {
    border-right: none;
  }

  .stripe tr:nth-child(2n + 1) {
    background: #f7f7f7;
  }
  #edit-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  #edit-area span {
    display: block;
    font-size: 14px;
    padding: 3px 0px;
    margin: 10px 0;
    text-align: center;
    color: var(--purple);
  }

  #edit-area span.active {
    border-bottom: solid 4px var(--purple);
    cursor: pointer;
  }

  #edit-area span::before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 0 0 15px;
  }
  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin: 0px auto 40px;

    .right-box {
      right: 0;
      bottom: 0;
      width: 25%;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 50%);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 25%;
      .mobile & {
        width: unset;
      }
    }
    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 10px;
        margin-right: 10px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
      width: 130px;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }
  .btn-sort-up {
    display: block;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: var(--purple) url("~@/assets/icons/ic_arrow_up.svg") no-repeat
      center center;
    margin: 5px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
  }
  .btn-sort-down {
    display: block;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: var(--purple) url("~@/assets/icons/ic_arrow_down.svg") no-repeat
      center center;
    margin: 5px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
  }
  /* タイトル */
  .header .title {
    width: 100%;
    box-sizing: border-box;
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_style.svg") no-repeat center center;
  }
}
</style>
